<!-- 个人认证信息 -->
<style lang="scss" scoped>
.personal-item-wrapper {
  background: #ffffff;

  .company-item-upload-box {
    display: flex;
    gap: 30px;
    .label {
      display: flex;
      justify-content: space-between;
    }
  }

  .required {
    &::before {
      content: '*';
      color: #ff0000;
      margin-right: 4px;
    }
  }

  .example {
    height: 28px;
    color: $color-primary;
    cursor: pointer;
    border-bottom: 1px solid $color-primary;
  }
}

.no-show-star {
  :deep() {
    .el-form-item__label {
      width: 100% !important;
      text-align: end;
      height: 22px;
      &::before {
        content: '' !important;
      }
    }
  }
}
</style>

<template>
  <div class="personal-item-wrapper">
    <el-form ref="formRef" :model="form" :rules="rules" size="large" label-position="top" label-width="90px">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="required mb-4px">
            上传证照(系统将自动识别填写证件信息，请核对识别结果，如有错误请手动修改。图片格式支持jpg/jpeg/png，单张图片大小不超过2M)
          </div>
          <div class="company-item-upload-box">
            <el-form-item label="" prop="legalIdentityCardFrontUrl">
              <div>
                <img-upload
                  v-model="form.legalIdentityCardFrontUrl"
                  :dir="OSS_DIR.ID_CARD"
                  height="160"
                  width="278"
                  :size-limit="2"
                  accept="image/jpg,image/jpeg,image/png"
                  @change="postOcrIdentityCardFront"
                >
                  <template #empty>
                    <div class="text-14px color-#666666"><span class="upload-txt">点击</span><span class="drag-txt">/拖拽至此处上传文件</span></div>
                    <div class="color-#999999">（支持jpg/jpeg/png格式，不超过 2 M）</div>
                  </template>
                </img-upload>
                <div class="label">
                  <span class="required">身份证人像面</span>
                  <span class="example" @click="preview(OssFile.IDENTITY_CARD_FRONT_EXAMPLE)">示例</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="" prop="legalIdentityCardBackUrl">
              <div class="">
                <img-upload
                  v-model="form.legalIdentityCardBackUrl"
                  :dir="OSS_DIR.ID_CARD"
                  height="160"
                  width="278"
                  :size-limit="2"
                  accept="image/jpg,image/jpeg,image/png"
                  @change="postOcrIdentityCardBack"
                >
                  <template #empty>
                    <div class="text-14px color-#666666"><span class="upload-txt">点击</span><span class="drag-txt">/拖拽至此处上传文件</span></div>
                    <div class="color-#999999">（支持jpg/jpeg/png格式，不超过 2 M）</div>
                  </template>
                </img-upload>
                <div class="label">
                  <span class="required">身份证国徽面</span>
                  <span class="example" @click="preview(OssFile.IDENTITY_CARD_BACK_EXAMPLE)">示例</span>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="8">
          <el-form-item label="姓名" prop="legalName">
            <el-input v-model="form.legalName" placeholder="请输入姓名" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="身份证号" prop="legalIdentityCard">
            <el-input v-model="form.legalIdentityCard" placeholder="请输入身份证号" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="性别" prop="legalSex">
            <el-select v-model="form.legalSex" placeholder="请选择性别">
              <el-option :value="1" label="男" />
              <el-option :value="2" label="女" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="身份证有效期" prop="legalIdentityCardFromDate">
            <el-date-picker v-model="form.legalIdentityCardFromDate" style="width: 100%" type="date" value-format="YYYY-MM-DD" placeholder="开始日期" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div class="no-show-star">
            <el-form-item prop="legalIdentityCardEndDate">
              <template #label>
                <el-checkbox
                  v-model="form.legalIdentityCardLongTerm"
                  class="long-term-checkbox"
                  :true-label="1"
                  :false-label="0"
                  label="结束日期：长期"
                  name="type"
                  @change="
                    (e) => {
                      longChange(e, 'legalIdentityCardEndDate')
                    }
                  "
                />
              </template>
              <el-date-picker
                v-model="form.legalIdentityCardEndDate"
                style="width: 100%"
                :disabled="!!form.legalIdentityCardLongTerm"
                type="date"
                value-format="YYYY-MM-DD"
                placeholder="结束日期"
              />
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="8">
          <el-form-item label="手机号码" prop="legalPhone">
            <el-input v-model="form.legalPhone" :is-number="true" maxlength="11" placeholder="请输入手机号码" />
          </el-form-item>
        </el-col>

        <el-col :span="16">
          <el-form-item label="证件地址" prop="legalHouseholdAddress">
            <el-input v-model="form.legalHouseholdAddress" placeholder="请选择证件地址" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="电子邮箱" prop="legalEmail">
            <el-input v-model="form.legalEmail" placeholder="请输入电子邮箱" />
          </el-form-item>
        </el-col>

        <el-col :span="16">
          <el-form-item label="居住地址" prop="legalHomeAddress">
            <el-input v-model="form.legalHomeAddress" placeholder="请输入居住地址" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <ImgViewer v-model:visible="showImgViewer" :url-list="currentUrlList" :show-mini-image="false" :prev-btn="false" :next-btn="false" />
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { OSS_DIR } from '@/constants/common'
import OssFile from '@/constants/oss-file'
import userApi from '@/apis/user'
import { isPhone, validateEmail, validateIDNumber } from '@/common/js/validator'
import { dealTime } from '@/utils/utils'
import { identifyEmpty } from './data'

const emit = defineEmits(['setFormData'])
const showImgViewer = ref(false)
const currentUrlList = ref([])
const preview = (url) => {
  showImgViewer.value = true
  currentUrlList.value = [url]
}
const form = ref({
  legalIdentityCardFrontUrl: null, // 身份证人像面
  legalIdentityCardBackUrl: null, // 身份证国徽面
  legalName: '', // 姓名
  legalIdentityCard: '', // 身份证号
  legalSex: '', // 性别
  legalIdentityCardFromDate: '', // 身份证有效期开始日期
  legalIdentityCardEndDate: '', // 身份证有效期结束日期
  legalIdentityCardLongTerm: 0, // 身份证有效期是否长期
  legalPhone: '', // 手机号码
  legalEmail: '', // 电子邮箱
  legalHouseholdAddress: '', // 证件地址
  legalHomeAddress: '', //居住地址
})

const props = defineProps({
  joinForm: {
    type: Object,
    default: () => {},
  },
})

//更新法人表单
watch(
  () => form.value,
  (newVal) => {
    emit('setFormData', newVal)
  },
  { deep: true },
)

watch(
  () => props.joinForm,
  (newVal) => {
    if (newVal) {
      for (const key in newVal) {
        if (newVal[key] !== undefined && newVal[key] !== null && key in form.value) {
          form.value[key] = newVal[key]
        }
      }
    }
  },
  { deep: true, immediate: true },
)
// 自定义手机号码验证规则
const checkPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入手机号码'))
  }
  if (!isPhone(value)) {
    return callback(new Error('输入手机号码格式不对'))
  }
  callback()
}

// 自定义法人证件号验证规则
const checkLegalIdentityCard = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入法人证件号'))
  }
  if (!validateIDNumber(value)) {
    return callback(new Error('输入法人证件号格式不对'))
  }
  callback()
}

// 自定义法人身份证结束日期检验规则
const checkLegalIdentityCardEndDate = (rule, value, callback) => {
  if (form.value.legalIdentityCardFromDate && value && dealTime(form.value.legalIdentityCardFromDate) > dealTime(value)) {
    callback(new Error('结束日期不能小于开始日期'))
  } else if (value || form.value.legalIdentityCardLongTerm) {
    callback()
  } else {
    callback(new Error('请选择结束日期'))
  }
}

// 自定义法人邮箱验证规则
const checkLegalEmail = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入法人电子邮箱'))
  }
  if (!validateEmail(value)) {
    return callback(new Error('输入法人电子邮箱格式不对'))
  }
  callback()
}

//长期赋值
const longChange = (e, key) => {
  e ? (form.value[key] = '2099-12-31') : (form.value[key] = '')
}

const rules = ref({
  legalName: [{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }],
  legalPhone: [{ required: true, validator: checkPhone, trigger: ['blur', 'change'] }],
  legalIdentityCard: [
    {
      required: true,
      validator: checkLegalIdentityCard,
      trigger: ['blur', 'change'],
    },
  ],
  legalIdentityCardFromDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
  legalIdentityCardEndDate: [
    {
      required: true,
      validator: checkLegalIdentityCardEndDate,
      trigger: 'change',
    },
  ],
  legalHouseholdAddress: [
    {
      required: true,
      message: '请输入居住地址',
      trigger: ['blur', 'change'],
    },
  ],
  legalEmail: [
    {
      required: true,
      validator: checkLegalEmail,
      trigger: ['blur', 'change'],
    },
  ],
  legalIdentityCardFrontUrl: [{ required: true, message: '请上传身份证人像面', trigger: 'none' }],
  legalIdentityCardBackUrl: [{ required: true, message: '请上传身份证国徽面', trigger: 'none' }],
  legalHomeAddress: [{ required: true, message: '请输入居住地址', trigger: ['blur', 'change'] }],
  legalSex: [{ required: true, message: '请选择性别', trigger: 'change' }],
})

//身份证正面ocr识别
const postOcrIdentityCardFront = async (url) => {
  form.value.legalIdentityCardFrontUrl = url
  if (!url) return
  const res = await userApi.postIdCardFrontOcr({
    identityCardFrontUrl: url,
  })
  //OCR识别数据处理 (无 || '--')
  identifyEmpty(res)

  emit('setFormData', {
    legalName: res.name,
    legalSex: res.sex,
    legalIdentityCard: res.identityCard,
    legalHouseholdAddress: res.householdAddress,
    legalIdentityCardFrontUrl: url,
  })
}

//身份证反面ocr识别
const postOcrIdentityCardBack = async (url) => {
  form.value.legalIdentityCardBackUrl = url
  if (!url) return
  const res = await userApi.postIdCardBackOcr({
    identityCardBackUrl: url,
  })
  //OCR识别数据处理 (无 || '--')
  identifyEmpty(res)

  emit('setFormData', {
    legalIdentityCardFromDate: res.identityCardFromDate, // 开始日期
    legalIdentityCardEndDate: res.identityCardEndDate, // 结束日期
    legalIdentityCardLongTerm: res.identityCardLongTerm, // 是否长期
    legalIdentityCardBackUrl: url,
  })
}

const formRef = ref(null) // 表单ref
defineExpose({
  form: computed(() => form.value),
  validate: () => {
    return formRef.value?.validate()
  },
})
</script>
